export default "__VITE_ASSET__BgnKn9rz__"